import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Heading } from '../../components/heading';
import { Text } from '../../components/text';
import { Button } from '../../components/button';
import { useUser } from '../../components/UserContext';

const BillingSuccess = () => {
  const navigate = useNavigate();
  const { orgData, loading: userLoading } = useUser();

  const [status, setStatus] = useState('processing'); // processing | success | timeout
  const [pollCount, setPollCount] = useState(0);

  // Poll for subscription activation
  useEffect(() => {
    if (userLoading) return;

    // Check if subscription is already active
    if (orgData?.subscriptionStatus === 'active' || orgData?.subscriptionStatus === 'trialing') {
      setStatus('success');
      return;
    }

    // Max 30 seconds of polling (15 attempts at 2s intervals)
    if (pollCount >= 15) {
      setStatus('timeout');
      return;
    }

    // Poll every 2 seconds
    const timer = setTimeout(() => {
      setPollCount(prev => prev + 1);
    }, 2000);

    return () => clearTimeout(timer);
  }, [orgData?.subscriptionStatus, userLoading, pollCount]);

  const handleGoToConfig = () => {
    navigate('/app/config');
  };

  if (status === 'processing') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 mx-auto mb-6">
            <div className="w-16 h-16 border-4 border-azul-surelia/20 border-t-azul-surelia rounded-full animate-spin" />
          </div>
          <Heading level={2} className="text-xl font-bold text-azul-surelia mb-3">
            Procesando tu suscripción
          </Heading>
          <Text className="text-azul-surelia/70">
            Estamos activando tu suscripción. Esto puede tomar unos segundos...
          </Text>
        </div>
      </div>
    );
  }

  if (status === 'timeout') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <Heading level={2} className="text-xl font-bold text-azul-surelia mb-3">
            Pago recibido
          </Heading>
          <Text className="text-azul-surelia/70 mb-6">
            Tu pago fue procesado correctamente. La activación de tu suscripción puede
            tomar unos minutos. Si no ves tu suscripción activa pronto, por favor
            contacta a soporte.
          </Text>
          <Button onClick={handleGoToConfig}>
            Ir a configuración
          </Button>
        </div>
      </div>
    );
  }

  // Success state
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
          <CheckCircleIcon className="w-8 h-8 text-green-600" />
        </div>
        <Heading level={2} className="text-xl font-bold text-azul-surelia mb-3">
          Suscripción activada
        </Heading>
        <Text className="text-azul-surelia/70 mb-6">
          Tu suscripción ha sido activada exitosamente. Ya puedes disfrutar de
          todas las funcionalidades de tu plan.
        </Text>
        <Button onClick={handleGoToConfig}>
          Ir a configuración
        </Button>
      </div>
    </div>
  );
};

export default BillingSuccess;
